import HttpService from '@/services/HttpService';
import { error } from '@/utils/error';
const getCollectivity = async ({ brand, collectivityNumber }) => {
    const path = '/clientcontroller/salesfunnelclient/collectiviteit';
    const payload = {
        Propositie: brand ?? 'BAP',
        Collectiviteitnummer: collectivityNumber
    };
    const { data } = (await HttpService.post(path, payload));
    if (!data) {
        error('Client controller call was unsuccessful', {
            path,
            payload: JSON.stringify(payload)
        });
    }
    return data;
};
const getCollectivities = async ({ brand, searchterm }) => {
    const path = '/clientcontroller/collectiviteitzoekerclient/Zoeken';
    const payload = {
        Propositie: brand ?? 'BAP',
        Versie: 'SF', // Versie opties zijn: SF | KD | <leeg>
        Zoektekst: searchterm
    };
    const { data } = (await HttpService.post(path, payload));
    if (data.isSucces === false) {
        error('Client controller call was unsuccessful', {
            path,
            payload: JSON.stringify(payload)
        });
    }
    return data.resultaten;
};
const getAlliances = async ({ brand }) => {
    const path = `/clientcontroller/collectiviteitzoekerclient/allianties?propositie=${brand}`;
    const { data } = (await HttpService.get(path));
    if (data.isSucces === false) {
        error('Client controller call was unsuccessful', {
            path
        });
    }
    return data.allianties;
};
const getUsps = async ({ brand, collectivityNumber }) => {
    const path = '/clientcontroller/salesfunnelclient/collectiviteitUsps';
    const payload = {
        Propositie: brand ?? 'BAP',
        Collectiviteitnummer: collectivityNumber
    };
    const { data } = (await HttpService.post(path, payload));
    if (!data) {
        error('Client controller call was unsuccessful', {
            path,
            payload: JSON.stringify(payload)
        });
    }
    return data;
};
const setCookie = async ({ brand, collectivityNumber }) => {
    const path = '/clientcontroller/salesfunnelclient/setcollectiviteitcookies';
    const payload = {
        Propositie: brand ?? 'BAP',
        Collectiviteitnummer: collectivityNumber
    };
    const { data } = await HttpService.post(path, payload);
    if (!data) {
        error('Client controller call was unsuccessful', {
            path,
            payload: JSON.stringify(payload)
        });
        return;
    }
};
export default {
    getCollectivity,
    getCollectivities,
    getAlliances,
    getUsps,
    setCookie
};
